import React from 'react';
import PropTypes from 'prop-types';

function GridFilter({ placeholderText = '', changeFilter }) {
  return (
    <div className="filter-container">
      <input
        type="text"
        name="filter"
        placeholder={placeholderText}
        className="form-control"
        onChange={(e) => changeFilter(e.target.value)}
      />
    </div>
  );
}

GridFilter.propTypes = {
  changeFilter: PropTypes.func,
  placeholderText: PropTypes.string,
};

export { GridFilter };
